<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <path class="cls-2" d="m57.19,81.11c-.33,0-.66-.1-.93-.31l-11.22-8.33-11.22,8.33c-.47.35-1.11.41-1.63.14-.53-.27-.86-.8-.86-1.39v-32.64c0-.86.7-1.56,1.56-1.56s1.56.7,1.56,1.56v29.53l9.66-7.17c.55-.41,1.31-.41,1.86,0l9.66,7.17v-20.33c0-.86.7-1.56,1.56-1.56s1.56.7,1.56,1.56v23.44c0,.59-.33,1.13-.86,1.39-.22.11-.46.17-.7.17Z"/>
  <path class="cls-2" d="m45.04,45.01c-7.98,0-14.48-6.5-14.48-14.48s6.49-14.48,14.48-14.48,14.48,6.5,14.48,14.48-6.5,14.48-14.48,14.48Zm0-26.88c-6.84,0-12.4,5.56-12.4,12.4s5.56,12.4,12.4,12.4,12.4-5.56,12.4-12.4-5.56-12.4-12.4-12.4Z"/>
  <path class="cls-1" d="m45.04,52.09c-11.89,0-21.56-9.67-21.56-21.56s9.67-21.56,21.56-21.56,21.56,9.67,21.56,21.56-9.67,21.56-21.56,21.56Zm0-40c-10.17,0-18.44,8.27-18.44,18.44s8.27,18.44,18.44,18.44,18.44-8.27,18.44-18.44-8.27-18.44-18.44-18.44Z"/>
  <path class="cls-3" d="m52.69,29.54l-2.91,2.83c-.2.19-.29.47-.24.74l.69,4c.12.68-.6,1.2-1.21.88l-3.6-1.89c-.24-.13-.53-.13-.78,0l-3.59,1.89c-.61.32-1.33-.2-1.21-.88l.69-4c.05-.28-.04-.55-.24-.74l-2.91-2.83c-.5-.48-.22-1.33.47-1.43l4.01-.58c.28-.04.51-.21.63-.46l1.8-3.64c.31-.62,1.19-.62,1.49,0l1.8,3.64c.12.24.36.42.63.46l4.01.58c.69.1.96.94.47,1.43Z"/>
</svg>
</template>

<script>
export default {
    name: "BrandRankIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #0f5b71;
  }
  .cls-2 {
    fill: #59c5c7;
  }
  .cls-3 {
    fill: #cfeae0;
  }
</style>